import { render, staticRenderFns } from "./digitalizar_encuesta.vue?vue&type=template&id=0b10b4f5&scoped=true"
import script from "./digitalizar_encuesta.vue?vue&type=script&lang=js"
export * from "./digitalizar_encuesta.vue?vue&type=script&lang=js"
import style0 from "./digitalizar_encuesta.vue?vue&type=style&index=0&id=0b10b4f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b10b4f5",
  null
  
)

export default component.exports